import React, { FC } from "react"

import { ActionIcon, Group, Menu, Text, Tooltip, useMantineTheme } from "@mantine/core"
import { useDisclosure, useMediaQuery } from "@mantine/hooks"
import { IconPencil, IconTrash } from "@tabler/icons-react"

import { DeviceDocument, GroupDocument, useDevices } from "../../../contexts/devices-context"
import DeleteGroupModal from "../delete-group-modal/DeleteGroupModal"
import { useLanguage } from "../../../contexts/language-context"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../../contexts/authentication-context"

type GroupsTableMenuProps = {
    devices: DeviceDocument[]
    group: GroupDocument
}

const GroupsTableItem: FC<GroupsTableMenuProps> = ({ group, devices }) => {
    const { L } = useLanguage()
    const [opened, { open, close }] = useDisclosure(false)
    const navigate = useNavigate()
    const theme = useMantineTheme()
    const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
    const { hasRole } = useAuth()

    return (
        <tr key={group.id}>
            <td>{group.name}</td>
            {mobile || (
                <td>
                    <Text color="dimmed">
                        {devices?.map(device => device.name).join(", ")}
                    </Text>
                </td>
            )}
            <td>
                <Group spacing="xs" noWrap>
                    <Tooltip label={L("Edit group")} withinPortal>
                        <ActionIcon
                            variant="outline"
                            disabled={!hasRole("edit-devices")}
                            onClick={() => navigate(group.id)}
                        >
                            <IconPencil size={18} />
                        </ActionIcon>
                    </Tooltip>
                    <Tooltip label={L("Delete group")} withinPortal>
                        <ActionIcon
                            color="red"
                            variant="filled"
                            disabled={!hasRole("edit-devices") || devices?.some(device => device.group === group.id)}
                            onClick={event => {
                                event.stopPropagation()
                                open()
                            }}
                        >
                            <IconTrash size={18} />
                        </ActionIcon>
                    </Tooltip>
                </Group>
                <DeleteGroupModal
                    opened={opened}
                    onClose={close}
                    group={group}
                    onClick={event => event.stopPropagation()}
                />
            </td>
        </tr>
    )
}

export default GroupsTableItem
